













































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import CreateInvoiceRequest from '@/models/Invoices/CreateInvoiceRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { InvoiceListModule } from '@/store/modules/invoiceList';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import { CompanyListModule } from '@/store/modules/companyList';
import { LocationListModule } from '@/store/modules/locationList';
import IconConstants from '@/lib/iconConstants';
import PageNames from '@/router/PageNames';
import CompanyProfileDto from '@/models/Companies/CompanyProfileDto';
import DeskDto from '@/models/Desks/DeskDto';
import BranchDto from '@/models/Branches/BranchDto';
import PositionDto from '@/models/Positions/PositionDto';
import LocationDto from '@/models/Locations/LocationDto';
import ajax from '@/lib/ajax';
import { AppModule } from '@/store/modules/app';
import InvoiceDto from '@/models/Invoices/InvoiceDto';
import ListUtils from '@/lib/listUtils';

@Component({
  name: 'InvoiceCreate',
})
export default class extends GiganautVueDialog {

  public valid = true;
  private entity = {
    company: null as CompanyProfileDto | null,
    location: null as LocationDto | null,
    invoiceType: 1, // Default to Temp invoices
    weekCommencingDate: '',
    purchaseOrderNumber: '',
    invoiceLineSuffix: '',
    desks: [] as DeskDto[],
    positions: [] as PositionDto[],
    locations: [] as LocationDto[]

  };
  private availableCompanyLocations: LocationDto[] = [];

  get companies() {
    return CompanyListModule.companies;
  }

  get desks() {
    return InvoiceListModule.desks;
  }

  get positions() {
    return AgencySettingsModule.positions;
  }

  get locations() {
    return this.availableCompanyLocations;
  }

  get loadingDialog() {
    return InvoiceListModule.loadingDialog;
  }

  // allowedDates(date: Date) {
  //   return new Date(date).getDay() === 1;
  // }

  async onCompanyChanged() {
    if (this.entity.company) {
      this.availableCompanyLocations = [];
      this.entity.locations = [];
      this.entity.location = null;
      
      // Get company locations
      await ajax.get(`/api/v1/agency/companies/${this.entity.company.id}/locations`)
        .then(response => {
          this.availableCompanyLocations = response.data || [];
        })
        .catch(error => {
          AppModule.handleApiError(error);
        });
    }
  }


  @Watch('dialog')
  async onDialogChanged(val: boolean) {
    if (val) {
      this.resetForm();
      
      // Load data from existing stores if needed
      if (CompanyListModule.companies.length === 0) {
        CompanyListModule.searchCompanies();
      }
      if (AgencySettingsModule.positions.length === 0) {
        await AgencySettingsModule.getPositions();
      }
      if (AgencySettingsModule.branches.length === 0) {
        await AgencySettingsModule.getBranches();
      }
      if (InvoiceListModule.desks.length === 0) {
        await InvoiceListModule.getDesks();
      }
    }
  }

  resetForm() {
    this.entity.company = null;
    this.entity.location = null;
    this.entity.invoiceType = 1; // Default to Temp invoices
    this.availableCompanyLocations = [];
    this.entity.weekCommencingDate = '';
    this.entity.purchaseOrderNumber = '';
    this.availableCompanyLocations = [];
    this.entity.desks = [];
    this.entity.positions = [];
    this.entity.locations = [];
    (this.$refs.form as any)?.resetValidation();
  }

  async create() {
    if (!this.valid) {
      return;
    }

    const request = new CreateInvoiceRequest();
    request.type = this.entity.invoiceType;
    request.companyId = this.entity.company?.id || '';
    if (this.entity.location) {
      request.locationId = this.entity.location.id
    }
    request.weekCommencingDate = this.entity.weekCommencingDate; // Send as string in yyyy-MM-dd format
    request.purchaseOrderNumber = this.entity.purchaseOrderNumber;
    request.invoiceLineSuffix = this.entity.invoiceLineSuffix;
    request.deskIds = this.entity.desks.map(d => d.id);
    request.positionIds = this.entity.positions.map(p => p.id);
    if (request.locationId !== '') {
      request.locationIds = this.entity.locations.map(l => l.id);
    }

    await InvoiceListModule.createInvoice(request);
    if (InvoiceListModule.newInvoiceId !== '') {
      this.$router.push({ name: PageNames.AgencyInvoiceDetails, params: { invoiceid: InvoiceListModule.newInvoiceId } });
    }
    this.dialog = false;
  }
}
